import axios from "axios";
import {restUrl} from "../../../../../apiUrl";
import {useContext} from "react";
import {Context} from "./Context";
import {useNavigate} from "react-router-dom";
import {partition, selectValPartition} from "../../component/AboutPre";

export const AiTextEditor = () => {
    const {chattingData, setChattingData, state, questions} = useContext(Context)
    
    const handleChange = (text,chatId)=>{
        setChattingData(prev =>
            prev.map(chat =>
                chat.id === chatId
                    ? {...chat, userEditText:text }
                    : chat
            )
        );
    }

    const navigate = useNavigate();

    return (
        <div>
            <div className={` w-full flex`}>
                <div className={`w-full`}>
                    <h1 className={`py-4  bg-[#516186] text-center font-bold text-white`}>
                        AI 응답
                    </h1>
                    {chattingData.length > 0 && chattingData.map((item, itemIdx) => {
                        const selectedAi =item["selectedAi"]
                        if(selectedAi === "") return;
                        let text = item["aiChat"][selectedAi] ??"응답을 선택하면 여기에 표시됩니다"
                        return <textarea cols="30" rows="10" value={text} readOnly key={'qfwenu'+itemIdx}
                                         className={`w-full text-black h-[10rem] text-xl p-3`}></textarea>
                    })}
                </div>
                <div className={`w-full`}>
                    <h1 className={`py-4  bg-[#516186] text-center font-bold text-white`}>
                        에디터
                    </h1>
                    {chattingData.length > 0 && chattingData.map((item, itemIdx) => {
                        return <textarea cols="30" rows="10" value={item["userEditText"]}
                                         onChange={(e)=>{handleChange(e.target.value,item["id"])}}
                                         className={`w-full text-black h-[10rem] text-xl p-3`}></textarea>
                    })}
                </div>
            </div>
            <div>
                <button onClick={async () => {
                    const hasInvalid = chattingData.some(item => !item.selectedAi);
                    if (hasInvalid) {
                        alert("선택된 AI가 없는 항목이 있습니다!");
                        return
                    }
                    const a = questions.flat().map(question => question.selectVal.join(selectValPartition));
                    a[0] = chattingData.map(item => item["userEditText"])
                    await axios.patch(`${restUrl}/activity_test_application?id=eq.${state.appId}`, {preview_response: a.join(partition)})
                    alert('저장되었습니다.')
                    navigate(-1)
                }} className={`w-full bg-slate-800 text-white px-5 py-5`}>제출하기
                </button>
            </div>
        </div>
    )
}